module.exports = __webpack_public_path__ + "media/images/icons/clock-2fd53935dafca0660e2edcfc1d3ac1c9.svg";